import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { AuthContext } from "providers/AuthProvider";
import { useContext } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { removeLocalStorage } from "shared/utils/Utils";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";
import { OrderInfoReducer } from "shared/redux/reducers/shopping/OrderInfoReducer";
import P from "components/P";
import Dummy from "components/Dummy";

function Profile() {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { userName } = useContext(AuthContext);

    const onSignoutClick = () => {
        NiceModal.show("logout", {
            message: t("confirmLogout"),
            confirmText: t("confirm"),
            cancelText: t("cancel"),
            onConfirm: onConfirm,
            onCancel: onCancel
        });
    }

    const onConfirm = () => {
        removeLocalStorage("token");
        dispatch(AuthReducer.actions.reset());
        dispatch(OrderInfoReducer.actions.reset());
        window.location.replace(`/ws/${id}/mobile`);
    }

    const onCancel = () => { }

    const onWithdrawalClick = () => {
        navigate(`/ws/${id}/mobile/settings/withdrawal`)
    }

    const profileItems = [
        {
            title: "계정 관리",
            items: [
                { 
                    label: "로그아웃", 
                    icon: fas.faSignOutAlt, 
                    onClick: onSignoutClick 
                },
                { 
                    label: "회원탈퇴", 
                    icon: fas.faUserMinus, 
                    onClick: onWithdrawalClick, 
                    color: "#FF6B6B" 
                }
            ]
        }
    ];

    return (
        <div style={{ height: "100%", backgroundColor: "#fff" }}>
            <Dummy height={"56px"} />
            <div style={{ padding: "20px" }}>
                {profileItems.map((section, index) => (
                    <div key={index} style={{ marginBottom: "32px" }}>
                        <P size={20} color={"#666"} weight={700} style={{ marginBottom: "12px" }}>
                            {section.title}
                        </P>
                        <div style={{
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            overflow: "hidden",
                            border: "1px solid #f5f5f5"
                        }}>
                            {section.items.map((item, itemIndex) => (
                                <div
                                    key={itemIndex}
                                    onClick={item.onClick}
                                    style={{
                                        padding: "16px",
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        borderBottom: itemIndex < section.items.length - 1 ? "1px solid #f5f5f5" : "none",
                                        backgroundColor: "#fff"
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={item.icon}
                                        style={{
                                            width: "20px",
                                            color: item.color || "#333",
                                            marginRight: "12px"
                                        }}
                                    />
                                    <div style={{ flex: 1 }}>
                                        <P
                                            size={15}
                                            weight={500}
                                            color={item.color || "#333"}
                                        >
                                            {item.label}
                                        </P>
                                        {item.description && (
                                            <P size={13} color="#666" style={{ marginTop: "4px" }}>
                                                {item.description}
                                            </P>
                                        )}
                                    </div>
                                    <FontAwesomeIcon
                                        icon={fas.faChevronRight}
                                        style={{
                                            marginLeft: "auto",
                                            color: "#999",
                                            fontSize: "14px"
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Profile; 